import { defineComponent, createBlock, openBlock, withCtx, createElementBlock, createCommentVNode, toDisplayString, createVNode } from 'vue';
import _sfc_main$1 from './basler-components.es73.js';
/* empty css                       */
import _sfc_main$2 from './basler-components.es79.js';
/* empty css                       */

const _hoisted_1 = { key: 0 };
const _hoisted_2 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Tile",
  props: {
    headerIcon: {},
    headline: {},
    content: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$1, {
        "header-gutter": true,
        class: "card--tile"
      }, {
        header: withCtx(() => [
          createVNode(_sfc_main$2, {
            name: _ctx.headerIcon,
            size: "large"
          }, null, 8, ["name"])
        ]),
        default: withCtx(() => [
          _ctx.headline ? (openBlock(), createElementBlock("h4", _hoisted_1, toDisplayString(_ctx.headline), 1)) : createCommentVNode("", true),
          _ctx.content ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: "rte-text",
            innerHTML: _ctx.content
          }, null, 8, _hoisted_2)) : createCommentVNode("", true)
        ]),
        _: 1
      });
    };
  }
});

export { _sfc_main as default };
